/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';
import { EnforcementCategoryEnum } from './enforcementCategoryEnum';
import { EnforcementStateEnum } from './enforcementStateEnum';


export interface EnforcementStatusRecord { 
    org_id?: string;
    service_type?: ServiceTypeEnum;
    current_state?: EnforcementStateEnum;
    enforcement_type?: object;
    scheduled_next_state?: EnforcementStateEnum;
    scheduled_next_enforcement_category?: EnforcementCategoryEnum;
    is_paused?: boolean;
    state_entered_ts?: Date;
    next_action_ts?: Date;
    pause_end_ts?: Date;
    created_ts?: Date;
    updated_ts?: Date;
}
export namespace EnforcementStatusRecord {
}


